import { IconName } from "@fortawesome/free-solid-svg-icons";

export default interface ProductTypeSpecs {
  [id: string]: ProductTypeSpec;
}

export enum SpecDisplay {
  None = 0,
  CheckBox = 1,
  RadioButton = 2,
  DropDown = 3,
  Slider = 4,
  Search = 5,
}
export enum SpecStatus {
  Hidden = 0,
  Display = 1,
}

export interface ProductTypeSpec {
  id: number;
  unit: string | null;
  description: string | null;
  title: string;
  icon: IconName;
  values: { [id: string]: string };
  selectedValues: null | string[];
  range: null | number[];
  selectedRange: null | number[];
  display: SpecDisplay;
  specStatus: SpecStatus;
}